import { ProgressSpinner } from "primereact/progressspinner";
import { Suspense } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type limitedCartDiscountsScreen_Query } from "@relay/limitedCartDiscountsScreen_Query.graphql";
import { numItemsPerPage } from "./limited-cart-discounts.constants";
import { QUERY } from "./limited-cart-discounts.graphql";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { LimitedCartDiscountTable } from "../../features/cart-discounts/limited-cart-discount-table";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const LimitedCartDiscountScreen = () => {
	const { t } = useTranslation("common");
	const canRead = useHasPermissions(["UserInAccountPermission_LimitedCartDiscountAdmin_Read"]);

	const limitedCartDiscounts = useLazyLoadQuery<limitedCartDiscountsScreen_Query>(QUERY, {
		numItemsPerPage,
	});

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("cartDiscount.screenTitle")}>
			<Suspense fallback={<ProgressSpinner />}>
				<LimitedCartDiscountTable
					enableFilter={true}
					enableActions={true}
					limitedCartDiscountsPerPage={numItemsPerPage}
					limitedCartDiscountsFragmentRef={limitedCartDiscounts}
				/>
			</Suspense>
		</BaseScreen>
	);
};
